import { Injectable, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { ListaBase } from '../crud/ListaBase';
import { AnalisePassagemBi03Service } from './../../pages/rmpv/analises-bi/bi03-analise-passagem/analise-passagem-bi03.service';
import { Filtros } from './../crud/Filtro/Filtros';
import { ConversaoLibraService } from './conversao-libra.service';

@Injectable()
export class ConversaoLibraConverte extends ListaBase implements OnInit {

  conversao = null;

  ngOnInit() {
  }

  constructor(service: ConversaoLibraService,
    toastr: ToastrService,
    router: Router,
    private translate: TranslateService,
    private serviceBi03: AnalisePassagemBi03Service) {
    super(service, toastr, router);
  }

  protected getListagemComFiltros(): boolean {
    return this.filtros.mes
      || this.filtros.ano
      || this.filtros.valor;
  }

  conversaoLibra(valor, mes = null, ano = null) {

    if (this.translate.currentLang == "br" || valor == 0) {
      return valor;
    } else {
      var dataAtual = new Date();
      if (mes == null) {
        mes = dataAtual.getMonth() + 1;
      }
      if (ano == null) {
        ano = dataAtual.getFullYear();
      }
      this.conversao = JSON.parse(sessionStorage.getItem('conversaoLibra'));
      return this.calculaValor(valor, mes, ano);
    }
  }

  calculaValor(valor, mes, ano) {
    var divisor = 1;
    this.conversao.forEach(dados => {
      if (dados.mes == mes && dados.ano == ano) {
        divisor = dados.valor;
      }
    });

    if (divisor == 1) {
      const mensagem = 'Parametro da moeda não cadastrado para o mês atual';
      this.toastr.error(mensagem, 'Erro');
    }

    return valor / divisor;
  }

  preencher() {
    this.conversao = JSON.parse(sessionStorage.getItem('conversaoLibra'));
    if (this.conversao == null) {
      
      let objFiltro: Filtros = new Filtros();
      this.service.buscar(objFiltro)
        .then(res => {
          sessionStorage.setItem('conversaoLibra', JSON.stringify(res.dados));
          this.conversao = res.dados;
        });
    }
  }


  preencherBi03(){
    this.conversao = JSON.parse(sessionStorage.getItem('conversaoLibra'));
    if (this.conversao == null) {
      let mercado: any;
      let grupo_economico: any;
      let regiao: any;
      let dealer: any;
      let data_inicial: any
      let data_final: any;
      this.serviceBi03.downloadCsvOneVoice(data_inicial, data_final, dealer, regiao, grupo_economico, mercado)
    }
  }
}
